import { IDisplayedCategory } from "./useMenuStructure"

const normalizePath = (path: string | undefined) => {
  if (!path) {
    return path
  }
  const trimmed = path.trim()
  const length = trimmed.length
  if (trimmed[length - 1] === '/') {
    return trimmed.substring(0, length - 1)
  }
  return trimmed
}

const getSelectedMenuPath = (
  currentUrlPath: string, 
  menuStructure: IDisplayedCategory[],
): string[] => {
  const normalizedOriginalPath = normalizePath(currentUrlPath)
    for(const category of menuStructure) {
      if (normalizePath(category.link) === normalizedOriginalPath) {
        return [category.id]
      }
      if (category.subcategories?.length) {
        for(const subcategory of category.subcategories) {
          if (normalizePath(subcategory.link) === normalizedOriginalPath) {
            return [category.id, subcategory.id]
          }
          if (subcategory.elements?.length) {
            for(const element of subcategory.elements) {
              if (normalizePath(element.link) === normalizedOriginalPath) {
                return [category.id, subcategory.id, element.id]
              }
            }
          }
        }
      }
    }
    return []
}

export default getSelectedMenuPath
